module.exports = __webpack_public_path__ + "img/20180815_151538_158.48bb473c.jpg";